export const movieCrewConfig = {
  movieCrewRoleListing: [
    'crew.role.directing.director',
    'crew.role.acting.actor',
    'crew.role.production.producer',
    'crew.role.writing.writer'
  ]
};
